import * as React from "react";

export const CourseGraduationCapIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.89118 10.2101V13.0449C3.89118 13.7813 4.29471 14.4673 4.94036 14.8204L9.98452 17.5745C10.5898 17.9074 11.3162 17.9074 11.9215 17.5745L16.9656 14.8204C17.6113 14.4673 18.0148 13.7813 18.0148 13.0449V10.2101L11.9215 13.5392C11.3162 13.8721 10.5898 13.8721 9.98452 13.5392L3.89118 10.2101ZM9.98452 0.464775L1.48008 5.10539C0.783985 5.48875 0.783985 6.49758 1.48008 6.88094L9.98452 11.5216C10.5898 11.8545 11.3162 11.8545 11.9215 11.5216L20.0325 7.09279V13.055C20.0325 13.6098 20.4864 14.0638 21.0413 14.0638C21.5961 14.0638 22.0501 13.6098 22.0501 13.055V6.58837C22.0501 6.21511 21.8484 5.88219 21.5255 5.7006L11.9215 0.464775C11.3162 0.14195 10.5898 0.14195 9.98452 0.464775Z"
      fill="#21394F"
    />
  </svg>
);

export const ClassIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 23 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.0478 12.3984H6.05278L6.05078 11.7754C6.05078 10.5164 6.15078 9.78944 7.63878 9.44544C9.32278 9.05644 10.9828 8.70944 10.1838 7.23644C7.81778 2.87344 9.50978 0.398438 12.0498 0.398438C14.5408 0.398438 16.2758 2.78144 13.9158 7.23744C13.1408 8.70144 14.7418 9.04944 16.4608 9.44644C17.9508 9.79044 18.0498 10.5184 18.0498 11.7794L18.0478 12.3984ZM22.8588 10.1844C21.5688 9.88644 20.3688 9.62544 20.9498 8.52744C22.7188 5.18544 21.4188 3.39844 19.5498 3.39844C18.2848 3.39844 17.3018 4.21544 17.3018 5.72244C17.3018 9.62544 19.5698 7.49244 19.5478 12.3984H24.0488L24.0508 11.9354C24.0508 10.9894 23.9768 10.4424 22.8588 10.1844ZM0.0527813 12.3984H4.55378C4.53278 7.49244 6.79978 9.62644 6.79978 5.72244C6.79978 4.21544 5.81678 3.39844 4.55178 3.39844C2.68278 3.39844 1.38278 5.18544 3.15278 8.52744C3.73378 9.62644 2.53378 9.88644 1.24378 10.1844C0.124781 10.4424 0.0507812 10.9894 0.0507812 11.9354L0.0527813 12.3984Z"
      fill="#21394F"
    />
  </svg>
);

export const CircleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    width="auto"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
  </svg>
);

export const PencilIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    width="auto"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z" />
  </svg>
);
